export const allPlays = [
  {
    id: "blockedPuntRecoveryInEndZone",
    name: "Blocked Punt Recovery in End Zone",
    fields: [
      "ballSpot",
      "ballSpotTeamId",
      "includesTouchdown",
      "lengthOfPlay",
      "notes",
      "player1Id",
      "teamInPossessionId",
      "timeRemaining",
      "quarter"
    ],
    player: {
      player1Id: "offense"
    }
  },
  {
    id: "blockedPuntReturn",
    name: "Blocked Punt Return",
    fields: [
      "ballSpot",
      "ballSpotTeamId",
      "distanceToGo",
      "down",
      "fumble",
      "includesTouchdown",
      "lengthOfPlay",
      "notes",
      "player1Id",
      "teamInPossessionId",
      "timeRemaining",
      "yardLine",
      "yardLineTeamId",
      "quarter"
    ],
    player: {
      player1Id: "offense"
    }
  },
  {
    id: "endOfQuarter",
    name: "End of Quarter",
    fields: ["notes", "timeEndOfHalftime", "quarter"]
  },
  {
    id: "fairCatch",
    name: "Fair Catch",
    fields: [
      "ballSpot",
      "ballSpotTeamId",
      "lengthOfPlay",
      "notes",
      "player1Id",
      "teamInPossessionId",
      "timeRemaining",
      "quarter"
    ],
    player: {
      player1Id: "offense"
    }
  },
  {
    id: "fieldGoal",
    name: "Field Goal",
    fields: [
      "distanceToGo",
      "down",
      "fumble",
      "includesScore",
      "lengthOfPlay",
      "notes",
      "player1Id",
      "teamInPossessionId",
      "timeRemaining",
      "yardLine",
      "yardLineTeamId",
      "quarter"
    ],
    players: {
      player1Id: "offense"
    }
  },
  {
    id: "fieldGoalReturn",
    name: "Field Goal Return",
    fields: [
      "ballSpot",
      "ballSpotTeamId",
      "fieldGoalReturnType",
      "fumble",
      "includesTouchdown",
      "lengthOfPlay",
      "notes",
      "player1Id",
      "teamInPossessionId",
      "timeRemaining",
      "yardLine",
      "yardLineTeamId",
      "quarter"
    ],
    player: {
      player1Id: "offense"
    }
  },
  {
    id: "freeKickReturn",
    name: "Free Kick Return",
    fields: [
      "ballSpot",
      "ballSpotTeamId",
      "fumble",
      "includesTouchdown",
      "lengthOfPlay",
      "notes",
      "player1Id",
      "teamInPossessionId",
      "timeRemaining",
      "yardLine",
      "yardLineTeamId",
      "quarter"
    ],
    player: {
      player1Id: "offense"
    }
  },
  {
    id: "fumbleRecoveryInEndZone",
    name: "Fumble Recovery In End Zone",
    fields: [
      "includesTouchdown",
      "notes",
      "player1Id",
      "teamInPossessionId",
      "timeRemaining",
      "quarter"
    ],
    player: {
      player1Id: "offense"
    }
  },
  {
    id: "fumbleReturn",
    name: "Fumble Return",
    fields: [
      "ballSpot",
      "ballSpotTeamId",
      "distanceToGo",
      "down",
      "fumble",
      "lengthOfPlay",
      "notes",
      "includesTouchdown",
      "player1Id",
      "teamInPossessionId",
      "timeRemaining",
      "yardLine",
      "yardLineTeamId",
      "quarter"
    ],
    player: {
      player1Id: "offense"
    }
  },
  {
    id: "incompletePass",
    name: "Incomplete Pass",
    fields: [
      "distanceToGo",
      "down",
      "notes",
      "player1Id",
      "teamInPossessionId",
      "timeRemaining",
      "yardLineTeamId",
      "yardLine",
      "quarter"
    ],
    players: {
      player1Id: "offense"
    }
  },
  {
    id: "interception",
    name: "Interception",
    fields: [
      "distanceToGo",
      "down",
      "notes",
      "player1Id",
      "teamInPossessionId",
      "timeRemaining",
      "quarter"
    ],
    players: {
      player1Id: "offense"
    }
  },
  {
    id: "interceptionReturn",
    name: "Interception Return",
    fields: [
      "ballSpot",
      "ballSpotTeamId",
      "fumble",
      "includesTouchdown",
      "lengthOfPlay",
      "notes",
      "player1Id",
      "teamInPossessionId",
      "timeRemaining",
      "yardLine",
      "yardLineTeamId",
      "quarter"
    ],
    players: {
      player1Id: "offense"
    }
  },
  {
    id: "kickoffReturn",
    name: "Kickoff Return",
    fields: [
      "ballSpot",
      "ballSpotTeamId",
      "fumble",
      "includesTouchdown",
      "lengthOfPlay",
      "notes",
      "player1Id",
      "teamInPossessionId",
      "timeRemaining",
      "yardLineTeamId",
      "yardLine",
      "quarter"
    ],
    players: {
      player1Id: "offense"
    }
  },
  {
    id: "muffedPunt",
    name: "Muffed Punt",
    fields: [
      "ballSpot",
      "ballSpotTeamId",
      "muffedPuntRecoveredByTeamId",
      "lengthOfPlay",
      "notes",
      "teamInPossessionId",
      "timeRemaining",
      "quarter"
    ]
  },
  {
    id: "officialTimeout",
    name: "Official Timeout",
    fields: ["notes", "timeRemaining", "quarter"]
  },
  {
    id: "onsideKickRecovery",
    name: "Onside Kick Recovery",
    fields: [
      "ballSpot",
      "ballSpotTeamId",
      "lengthOfPlay",
      "notes",
      "teamInPossessionId",
      "timeRemaining",
      "quarter"
    ]
  },
  {
    id: "pass",
    name: "Pass",
    fields: [
      "ballSpot",
      "ballSpotTeamId",
      "convertsFirstDown",
      "distanceToGo",
      "down",
      "fumble",
      "includesTouchdown",
      "lengthOfPlay",
      "notes",
      "player1Id",
      "player2Id",
      "teamInPossessionId",
      "timeRemaining",
      "yardLineTeamId",
      "yardLine",
      "quarter"
    ],
    players: {
      player1Id: "offense",
      player2Id: "offense"
    }
  },
  {
    id: "PATBlockedKickReturn",
    name: "PAT Blocked Kick Return",
    fields: [
      "ballSpot",
      "ballSpotTeamId",
      "fumble",
      "includesScore",
      "lengthOfPlay",
      "notes",
      "player1Id",
      "teamInPossessionId",
      "timeRemaining",
      "yardLine",
      "yardLineTeamId",
      "quarter"
    ],
    player: {
      player1Id: "offense"
    }
  },
  {
    id: "PATFumbleReturn",
    name: "PAT Fumble Return",
    fields: [
      "ballSpot",
      "ballSpotTeamId",
      "fumble",
      "includesScore",
      "lengthOfPlay",
      "notes",
      "player1Id",
      "teamInPossessionId",
      "timeRemaining",
      "yardLine",
      "yardLineTeamId",
      "quarter"
    ],
    player: {
      player1Id: "offense"
    }
  },
  {
    id: "PATInterceptionReturn",
    name: "PAT Interception Return",
    fields: [
      "ballSpot",
      "ballSpotTeamId",
      "fumble",
      "includesScore",
      "player1Id",
      "lengthOfPlay",
      "notes",
      "teamInPossessionId",
      "timeRemaining",
      "yardLine",
      "yardLineTeamId",
      "quarter"
    ],
    player: {
      player1Id: "offense"
    }
  },
  {
    id: "PATKick",
    name: "PAT Kick",
    fields: [
      "includesScore",
      "notes",
      "PATBlocked",
      "player1Id",
      "teamInPossessionId",
      "quarter"
    ],
    player: {
      player1Id: "offense"
    }
  },
  {
    id: "PATPass",
    name: "PAT Pass",
    fields: [
      "includesScore",
      "notes",
      "player1Id",
      "player2Id",
      "teamInPossessionId",
      "quarter"
    ],
    player: {
      player1Id: "offense",
      player2Id: "offense"
    }
  },
  {
    id: "PATRun",
    name: "PAT Run",
    fields: [
      "includesScore",
      "notes",
      "player1Id",
      "teamInPossessionId",
      "quarter"
    ],
    player: {
      player1Id: "offense"
    }
  },
  {
    id: "penaltyDefense",
    name: "Penalty Defense",
    fields: [
      "ballSpot",
      "ballSpotTeamId",
      "convertsFirstDown",
      "distanceToGo",
      "down",
      "fumble",
      "lengthOfPlay",
      "notes",
      "teamInPossessionId",
      "timeRemaining",
      "yardLine",
      "yardLineTeamId",
      "quarter"
    ]
  },
  {
    id: "penaltyOffense",
    name: "Penalty Offense",
    fields: [
      "ballSpot",
      "ballSpotTeamId",
      "distanceToGo",
      "down",
      "fumble",
      "includesFumble",
      "lengthOfPlay",
      "notes",
      "teamInPossessionId",
      "timeRemaining",
      "yardLineTeamId",
      "yardLine",
      "quarter"
    ]
  },
  {
    id: "punt",
    name: "Punt",
    fields: [
      "ballSpot",
      "ballSpotTeamId",
      "distanceToGo",
      "down",
      "fumble",
      "lengthOfPlay",
      "notes",
      "player1Id",
      "teamInPossessionId",
      "timeRemaining",
      "yardLineTeamId",
      "yardLine",
      "quarter"
    ],
    players: {
      player1Id: "offense"
    }
  },
  {
    id: "puntReturn",
    name: "Punt Return",
    fields: [
      "ballSpot",
      "ballSpotTeamId",
      "fumble",
      "includesTouchdown",
      "lengthOfPlay",
      "notes",
      "player1Id",
      "teamInPossessionId",
      "timeRemaining",
      "yardLine",
      "yardLineTeamId",
      "quarter"
    ],
    players: {
      player1Id: "offense"
    }
  },
  {
    id: "quarterbackKneel",
    name: "Quarterback Kneel",
    fields: [
      "ballSpot",
      "ballSpotTeamId",
      "distanceToGo",
      "down",
      "player1Id",
      "lengthOfPlay",
      "notes",
      "teamInPossessionId",
      "timeRemaining",
      "yardLine",
      "yardLineTeamId",
      "quarter"
    ],
    player: {
      player1Id: "offense"
    }
  },
  {
    id: "run",
    name: "Run",
    fields: [
      "ballSpot",
      "ballSpotTeamId",
      "convertsFirstDown",
      "distanceToGo",
      "down",
      "fumble",
      "includesTouchdown",
      "lengthOfPlay",
      "notes",
      "player1Id",
      "teamInPossessionId",
      "timeRemaining",
      "yardLineTeamId",
      "yardLine",
      "quarter"
    ],
    players: {
      player1Id: "offense"
    }
  },
  {
    id: "safety",
    name: "Safety",
    fields: [
      "ballSpot",
      "ballSpotTeamId",
      "distanceToGo",
      "down",
      "lengthOfPlay",
      "notes",
      "player1Id",
      "safetyType",
      "teamInPossessionId",
      "timeRemaining",
      "yardLine",
      "yardLineTeamId",
      "quarter"
    ],
    player: {
      player1Id: "offense"
    }
  },
  {
    id: "timeout",
    name: "Timeout",
    fields: ["notes", "teamCalledTimeout", "timeRemaining", "quarter"]
  },
  {
    id: "touchback",
    name: "Touchback",
    fields: [
      "ballSpot",
      "ballSpotTeamId",
      "notes",
      "teamInPossessionId",
      "timeRemaining",
      "quarter"
    ],
    players: {
      player1Id: "offense"
    }
  },
  {
    id: "weatherDelay",
    name: "Weather Delay",
    fields: ["time", "notes", "quarter"]
  }
];
